// extracted by mini-css-extract-plugin
export default {"p_tye":"fdaf74480c","slcted":"_70774b5c92","slc_color":"db392657b7","item_p":"_855e636112","r0":"d1d1d05f0a"};